import { BaseChannel } from "@sendbird/chat";
import { GroupChannel } from "@sendbird/chat/groupChannel";
import { getUpcomingShiftsGrouped } from "@src/app/store/ongoingShifts/apiV2";
import { Dispatch } from "redux";

import { ActionType } from "./model";

export const setChannels = async (dispatch: Dispatch, channels: GroupChannel[]) => {
  dispatch({
    type: ActionType.SET_CHANNELS,
    data: {
      channels,
    },
  });

  if (!channels.length) {
    return;
  }

  fetchAndSetUpcomingShifts(dispatch);
};

export const fetchAndSetUpcomingShifts = async (dispatch: Dispatch) => {
  const shiftsByFacility = await getUpcomingShiftsGrouped();

  dispatch({
    type: ActionType.SET_UPCOMING_SHIFTS,
    data: {
      shiftsByFacility,
    },
  });
};

export const updateChannel = async (dispatch: Dispatch, channel: BaseChannel) => {
  dispatch({
    type: ActionType.UPDATE_CHANNEL,
    data: {
      channel,
    },
  });
};
